<script setup>
import { ref } from 'vue';
import { useLocalizationStore } from '../../stores/localizationStore';
import Icon from "../Common/Icon.vue";
import { useRouter } from 'vue-router';

const { languages } = useLocalizationStore();

const router = useRouter();

const isOpen = ref(false);

function toggle(){
    isOpen.value = !isOpen.value;
}

function onLanguageClick(languageCode){
    isOpen.value = false;

    const route = router.currentRoute.value;
    const newParams = { ...route.params, locale: languageCode };

    router.replace({name: route.name, params: newParams});
}

function isActive(languageCode){
    return router.currentRoute.value.params.locale === languageCode;
}
</script>

<template>
    <div class="relative">
        <button type="button" @click="toggle()">
            <Icon v-if="!isOpen" name="globe" class="size-6 -mb-1 4k:-mb-2 4k:size-8" />
            <Icon v-if="isOpen" name="close" class="size-6 -mb-1 4k:-mb-2 4k:size-8" />
        </button>

        <div 
            :class="isOpen ? 'translate-y-0 opacity-100 pointer-events-auto' : 'translate-y-3 opacity-0 pointer-events-none'"
            class="absolute left-0 -translate-x-1/2 top-[130%] bg-gray-900 rounded-md shadow-lg z-50 text-white r-text-22 py-5 transition duration-300"
        >
            <button
                type="button"
                v-for="language in languages"
                :key="language.code"
                @click="onLanguageClick(language.code)"
                class="group flex items-center gap-x-5 px-5 py-2 hover:bg-white/10 transition w-full text-left"
                :class="isActive(language.code) ? 'opacity-50' : ''"
            >
                <div class="shrink-0 h-5 aspect-video relative group-hover:translate-x-1 transition-transform duration-300">
                    <img class="absolute left-0 top-0 w-full h-full object-cover" :src="language.flag">
                </div>

                <span v-text="language.label"></span>
            </button>
        </div>
    </div>
</template>
